import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./FloatingPromo.css";

const API_BASE = process.env.REACT_APP_API_URL || (window.location.hostname !== "localhost" ? "/api" : "http://localhost:5000/api");

const FloatingPromo = () => {
  const [promo, setPromo] = useState(null);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Check if dismissed in this session
    const wasDismissed = sessionStorage.getItem("promo_dismissed");
    if (wasDismissed) {
      setDismissed(true);
      return;
    }

    // Fetch active promo
    fetch(`${API_BASE}/stats/promotions`)
      .then((r) => r.json())
      .then((data) => {
        const list = Array.isArray(data) ? data : [];
        if (list.length > 0) {
          setPromo(list[0]);
          // Slight delay before showing
          setTimeout(() => setVisible(true), 1500);
        }
      })
      .catch(() => {});
  }, []);

  const handleDismiss = (e) => {
    e.stopPropagation();
    setVisible(false);
    setDismissed(true);
    sessionStorage.setItem("promo_dismissed", "true");
  };

  const handleClick = () => {
    navigate("/khuyen-mai");
  };

  if (dismissed || !promo) return null;

  return (
    <div
      className={`floating-promo ${visible ? "floating-promo--visible" : ""}`}
      onClick={handleClick}
      title="Xem khuyến mãi"
    >
      <button
        className="floating-promo__close"
        onClick={handleDismiss}
        title="Ẩn quảng cáo"
      >
        ×
      </button>

      <div className="floating-promo__badge">🔥 Ưu đãi</div>

      {promo.image_url ? (
        <img
          src={(() => {
            const cleaned = promo.image_url.replace("http://localhost:5000", "");
            return cleaned.startsWith("http") ? cleaned : `${process.env.REACT_APP_BACKEND_URL || (window.location.hostname !== "localhost" ? "" : "http://localhost:5000")}${cleaned}`;
          })()}
          alt={promo.title}
          className="floating-promo__img"
        />
      ) : (
        <div className="floating-promo__placeholder">🎁</div>
      )}

      <div className="floating-promo__content">
        <p className="floating-promo__title">{promo.title}</p>
        <span className="floating-promo__cta">Xem ngay →</span>
      </div>
    </div>
  );
};

export default FloatingPromo;
